// extracted by mini-css-extract-plugin
module.exports = {"budgetPreviewContainer":"styles_budgetPreviewContainer_2wFo9aapsoUK2F_gvtuzaN"};